<template>
    <div class="collection-item" v-if="mission.status == 2">
        <div class="row1">
            <!--{{ mission.desc }}-->
            {{ $t(mission.desc) }}
        </div>
        <div class="row2">
            <div class="progress">
                <div class="progress-process" :style="{ 'width': (100 * mission.process / mission.max_process) + '%' }"></div>
                <span>{{ mission.process }}/{{ mission.max_process }}</span>
            </div>
        </div>
        <div class="row3">
            <button class="btn btn-ito-2-large checked">
                {{ mission.key_reward }}
                <i class="ito-icon-lock-white"></i>
                <i class="ito-icon-checked-white"></i>
            </button>
        </div>
    </div>
    <div class="collection-item" v-else-if="mission.status == 1">
        <div class="row1">
            {{ $t(mission.desc) }}
        </div>
        <div class="row2">
            <div class="progress">
                <div class="progress-process" :style="{ 'width': (100 * mission.process / mission.max_process) + '%' }"></div>
                <span>{{ mission.process }}/{{ mission.max_process }}</span>
            </div>
        </div>
        <div class="row3">
            <button class="btn btn-ito-2-large" @click="claim">
                {{ $t('claim') }} {{ mission.key_reward }} <i class="ito-icon-lock-white"></i>
            </button>
        </div>
    </div>
    <div class="collection-item" v-else-if="mission.status == 0">
        <div class="row1">
            {{ $t(mission.desc) }}
        </div>
        <div class="row2">
            <div class="progress">
                <div class="progress-process" :style="{ 'width': (100 * mission.process / mission.max_process) + '%' }"></div>
                <span>{{ mission.process }}/{{ mission.max_process }}</span>
            </div>
        </div>
        <div class="row3">
            <button class="btn btn-ito-2-large" disabled>
                {{ $t('claim') }} {{ mission.key_reward }} <i class="ito-icon-lock-white"></i>
            </button>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from "axios";
import { claimChestDailyChallenge, claimKeyDailyChallenge } from "../../models/reward";
import { soundClick, soundGetReward, soundClaimKey } from '../../utils/utils';

export default {
    name: "DailyChallengeMissionItem",

    props: ['mission'],

    computed: {
        ...mapGetters([
            'user_info'
        ], () => {
            if (this.user_info) {
                return this.user_info
            }

            return {
                gem: 0
            }
        })
    },

    data() {
        return {};
    },

    created() {

    },

    methods: {
        claim() {
            const that = this;
            that.user_info.dailychallenge_noti = 1;
            that.getSoundClick();
            this.handleGACustomEvent('IP1_W_0001');
            claimKeyDailyChallenge({
                id: that.mission.id,
            }).then((response) => {
                if (response.data.code != 0) {
                    return;
                }
                const new_key_collect = response.data.results.key_collect || 0;
                const new_key_reward = response.data.results.key_reward || 0;
                const new_mission_id = response.data.results.id || that.mission.id;
                const new_mission_status = response.data.results.status || that.mission.status;
                const new_challenges = response.data.results.challenge || [];
                that.user_info.dailychallenge_noti = response.data.results.dailychallenge_noti || 0;
                this.$emit('updateNewMission', new_key_collect, new_mission_id, new_mission_status, new_key_reward)
                this.$emit('updateNewChallenge', new_challenges, new_key_collect)
                const gem_txt = new_key_reward > 0 ? '+' + new_key_reward : new_key_reward;
                $('#congratulation_lock').text(gem_txt);
                that.getSoundClaimKey();
                $('#getRewardedLockModal').modal('show');
            }).catch(({ response }) => {
                console.error(response);
            });
        },

        getSoundClick() {
            soundClick();
        },

        getSoundGetReward() {
            soundGetReward();
        },

        getSoundClaimKey() {
            soundClaimKey();
        },
        handleGACustomEvent(element) {
            var user_id = this.user_info.user_id || 0;
            var school_id_ref = parseInt(this.user_info.school_id_ref) || 0;
            var params = {
                'w_user_id': user_id,
                'school_id': school_id_ref
            };
            params[element] = user_id + '|' + school_id_ref;
            gtag('event', element, params);
        },
    }
}
</script>

<style scoped></style>
